import { z } from 'zod';
export const HtmlWidgetSchema = z.object({
    document: z.string().describe('The sanitized widget HTML, with placeholders for its data'),
    data: z.record(z.string(), z.unknown()).describe('The data the document reads'),
    placement: z.enum(['inline', 'panel']),
    runtime: z.string().length(16).describe('Hash of the widget runtime this widget was made with'),
    title: z.string().optional(),
    source: z
        .object({
        widgetDefinitionId: z.string(),
        version: z.union([z.number().int().positive(), z.literal('draft')]),
    })
        .optional()
        .describe('The published widget it was filled from, and which version'),
});
export const HtmlWidgetKey = 'html-widget:v1';
export const HtmlWidgetKind = 'html_widget';
/** Artifacts are unique per key in a conversation, so each widget gets its own key. */
export const htmlWidgetKey = (widgetId) => `${HtmlWidgetKey}:${widgetId}`;
export const isHtmlWidgetKey = (key) => key.startsWith(`${HtmlWidgetKey}:`);
